var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-bar-item",on:{"click":_vm.itemclick}},[(_vm.isactive)?_c('div',[_vm._t("item-img")],2):_c('div',[_vm._t("item-img-active")],2),_c('div',{style:(_vm.activestyle)},[_vm._t("item-text")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }